import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subscription, timer } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DPO_CONSTANT } from './../../utils/constant';
import { CacheService } from './../../services/cache.service';
import { AuthenticationService } from './../../services/authentication.service';
import { CommonService } from './../../services/common.service';
import { TranslateService} from '@ngx-translate/core';   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
import { AppConfig } from './../../modules/app.config';  //CAP-20753: Imported AppConfig file for Client related Changes

@Component({
  selector: 'dpo-root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit, OnDestroy {

  // Define the preoperties of the component
  myApp: any;
  subscription: Subscription;

  constructor(private router: Router,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private matPaginatorIntl: MatPaginatorIntl,
    private cacheService: CacheService,
    private apiconfig :AppConfig,         //CAP-20753: Added AppConfig file for Client related Changes
    private translate:TranslateService,   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
    private authenticationService: AuthenticationService,
    private toastrService: ToastrService,
    private commonService: CommonService) {
    // Register all the SVG icons for the application
    iconRegistry.addSvgIcon('menu', sanitizer.bypassSecurityTrustResourceUrl('./../../assets/icons/menu.svg'));
    iconRegistry.addSvgIcon('assignment', sanitizer.bypassSecurityTrustResourceUrl('./../../assets/icons/assignment.svg'));
    iconRegistry.addSvgIcon('group', sanitizer.bypassSecurityTrustResourceUrl('./../../assets/icons/group.svg'));
    iconRegistry.addSvgIcon('search', sanitizer.bypassSecurityTrustResourceUrl('./../../assets/icons/search.svg'));
    iconRegistry.addSvgIcon('description', sanitizer.bypassSecurityTrustResourceUrl('./../../assets/icons/description.svg'));
    iconRegistry.addSvgIcon('shopping_cart', sanitizer.bypassSecurityTrustResourceUrl('./../../assets/icons/shopping_cart.svg'));
    iconRegistry.addSvgIcon('control_point', sanitizer.bypassSecurityTrustResourceUrl('./../../assets/icons/control_point.svg'));
    iconRegistry.addSvgIcon('library_add_check', sanitizer.bypassSecurityTrustResourceUrl('./../../assets/icons/library_add_check.svg'));
    iconRegistry.addSvgIcon('power_settings', sanitizer.bypassSecurityTrustResourceUrl('./../../assets/icons/power_settings.svg'));

    // Apply language into page
    this.authenticationService.event.subscribe(refreshEvent => {    //CAP-20457: LOT1.1: Translation Service changed to translate for JSON
      setTimeout(() => {
        let currentUrl = window.location.href.split('?')[0].split('/#')[1];
        this.router.navigate([currentUrl]);
      }, 1000);
    })

    // Code for reload component without refresh
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.myApp = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.router.navigated = false;
      }
    });

  }

  ngOnInit() {    
  //CAP-20457: LOT1.1:START - Translation Service changed to translate for JSON
    if(localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE)) {
      this.translate.use(localStorage.getItem(DPO_CONSTANT.CACHE_I18N_LOCALE));
    }
    else {
      this.translate.use(DPO_CONSTANT.DEFAULT_LOCALE);
      localStorage.setItem(DPO_CONSTANT.CACHE_I18N_LOCALE, DPO_CONSTANT.DEFAULT_LOCALE);
    }


    this.translate.onLangChange.subscribe(() =>{
    // Load the table's label from i18n based on selected language
      this.matPaginatorIntl.itemsPerPageLabel = this.translate.instant('dpo.i18n.table.pagination.itemPerPage');
      this.matPaginatorIntl.firstPageLabel = this.translate.instant('dpo.i18n.table.pagination.firstPage');
      this.matPaginatorIntl.lastPageLabel = this.translate.instant('dpo.i18n.table.pagination.lastPage');
      this.matPaginatorIntl.nextPageLabel = this.translate.instant('dpo.i18n.table.pagination.nextPage');
      this.matPaginatorIntl.previousPageLabel = this.translate.instant('dpo.i18n.table.pagination.previousPage');
    });
   //CAP-20457: LOT1.1: STOP - Translation Service changed to translate for JSON
    // Call intializeValidateTokenCounter method
    setTimeout(() => {
      this.intializeValidateTokenCounter();
    }, 5000);

  }

  ngOnDestroy() {
    if (this.myApp) {
      this.myApp.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // Execute before unload
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    this.cacheService.clear();
  }

  // Method to call validate token API  in defined interval
  intializeValidateTokenCounter() {
    let timeInterval = this.apiconfig.tokenInterval * 60 * 1000;     //CAP-20753: Fetched from AppConfig for Client related Changes
    this.subscription = timer(0, timeInterval).subscribe(result => {
      let queryParams = this.cacheService.getItem(DPO_CONSTANT.CACHE_QUERY_PARAMS);
      if (queryParams && queryParams[DPO_CONSTANT.QP_TOKEN]) {
        let token = queryParams[DPO_CONSTANT.QP_TOKEN];
        this.commonService.validateToken(token).subscribe(response => {
        }, error => {
          if (error && error.status && (error.status === 401) && error.error) {
            this.toastrService.warning(this.translate.instant('dpo.i18n.message.token.expired'), this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          } else if (error && error.status && (error.status === 400 || error.status === 503) && error.error) {
            this.toastrService.warning(error.error, this.translate.instant('dpo.i18n.message.toastr.warning'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          } else {
            this.toastrService.error(this.translate.instant('dpo.i18n.message.record.error'), this.translate.instant('dpo.i18n.message.toastr.error'), {closeButton: true,});   //CAP-20457: LOT1.1: Translation Service changed to translate for JSON + close button added
          }
          this.authenticationService.unauthenticateUser();
        });
      }
    });
  }

}
